import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
/**
 * @fragment FieldValueFragment
 * @since 1.0.0
 */
export const FieldValueFragment = gql `
  fragment FieldValueFragment on FieldValue {
    id
    entity
    entityId
    value
    createdAt
    updatedAt

    field {
      ...FieldFragment
    }
  }
  ${FieldFragment}
`;
